<script>
export default {
  name: 'BookingRowSkeleton',
  props: {
    colspan: {
      type: Number,
      default: 14, // adjust based on your headers + extra columns
    },
  },
}
</script>

<template>
  <tr class="skeleton-row">
    <td :colspan="colspan" class="skeleton-wrapper">
      <div
        v-for="i in 1"
        :key="`skeleton-line-${i}`"
        class="skeleton-line"
      ></div>
    </td>
  </tr>
</template>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';
@import '@/styles/bookingList/booking-row-skeleton.scss';
</style>
